var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75719 9.13441e-07C9.83245 -0.000133495 9.90699 0.0145664 9.97656 0.0432603C10.0461 0.0719542 10.1094 0.114079 10.1627 0.167227L15.8323 5.8369C15.9397 5.94429 16 6.08993 16 6.24179C16 6.39365 15.9397 6.53929 15.8323 6.64668C15.2825 7.19647 14.6045 7.32017 14.1108 7.32017C13.9081 7.32017 13.7271 7.29956 13.5839 7.2755L9.99428 10.8651C10.0888 11.2459 10.1501 11.6341 10.1775 12.0254C10.2302 12.8295 10.1409 13.9577 9.35287 14.7457C9.24547 14.8531 9.09983 14.9134 8.94797 14.9134C8.79611 14.9134 8.65047 14.8531 8.54308 14.7457L5.30278 11.5066L1.65815 15.1512C1.4348 15.3745 0.261925 16.1843 0.0385747 15.961C-0.184776 15.7376 0.625013 14.5636 0.848364 14.3414L4.49299 10.6968L1.25383 7.45647C1.14647 7.34908 1.08615 7.20344 1.08615 7.05158C1.08615 6.89972 1.14647 6.75408 1.25383 6.64668C2.04186 5.85866 3.17006 5.76817 3.97413 5.82201C4.36546 5.84943 4.75367 5.91074 5.1344 6.00527L8.72405 2.41677C8.69409 2.24235 8.67876 2.06572 8.67823 1.88875C8.67823 1.39623 8.80194 0.718159 9.35287 0.167227C9.4602 0.0601693 9.60559 3.31206e-05 9.75719 9.13441e-07V9.13441e-07Z",
    fill: "#21242B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinned);
export default __webpack_public_path__ + "static/media/pinned.14d5221eab1d98b04537435980734b27.svg";
export { ForwardRef as ReactComponent };